import { render } from "./Customers.vue?vue&type=template&id=2aa14ee8&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./custom-customers.scss?vue&type=style&index=0&id=2aa14ee8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa14ee8"]])

export default __exports__